import { Slash } from "@insite/mobius/Breadcrumbs";
import getColor from "@insite/mobius/utilities/getColor";
import { pxToRem } from "@store/Framework/Common/Utilities/unitHelper";
import Styleguide from "@store/Framework/Types/Styleguide";
import { siteWidthStyles } from "@store/Themes/common/mixins/common";
import { linkStyles } from "@store/Themes/common/mixins/link";
import { css } from "styled-components";

const breadcrumbs: Styleguide["breadcrumbs"] = {
    defaultProps: {
        typographyProps: {
            color: "inherit",
            size: "inherit",
        },
        css: css`
            ${siteWidthStyles()}
            padding-top: ${pxToRem(20)};
            flex-wrap: wrap;
            color: ${getColor("text.accent")};

            ${({ theme }) => `
                font-size: ${theme.design.typography.size.smallest};
            `}

            ${Slash} {
                margin: 0 ${pxToRem(8)};
            }

            a {
                ${linkStyles("inherit", "text.linkAltHover", false, true)}
            }

            [aria-current="page"] {
                color: ${getColor("common.borderDark")}; /* Store Custom Code */
                font-weight: ${x => x.theme.design.typography.weight.bold};
            }
        `,
    },
};

export default breadcrumbs;
